(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["st-back-button"] && !Shopify.designMode) return;
  try {
    (function () {
  document.addEventListener("click", function (e) {
    const btn = e.target.closest(".st-back-button");
    if (!btn) return;

    e.preventDefault();

    const referrer = document.referrer;
    const sameSiteReferrer = referrer && referrer.includes(window.location.origin);

    if (sameSiteReferrer && window.history.length > 1) {
      window.history.back();
    } else {
      window.location.href = "/";
    }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
